import { IconSign } from '@/components/design/icons';
import type { FileDropAction } from './types';
import { useAuthStore } from '@/stores/auth';
import SignDocumentDropFlow from './SignDocumentDropFlow.vue';

/**
 * Start a signature request from dropped file(s). Only offered when the user has
 * the signing permission. Supports multiple files (the signature page accepts
 * several documents).
 */
export const signDocumentAction: FileDropAction = {
  key: 'sign-documents',
  label: 'Sign documents',
  icon: IconSign,
  component: SignDocumentDropFlow,
  isAvailable: () => useAuthStore().userPermissions.can_use_signing,
};
